import { useEffect, useRef } from 'react';
import { useStoryStore } from '@store/storyStore';

/**
 * AutoAdvanceManager component
 * Handles automatic advancement when narrative video/audio finishes
 */
export function AutoAdvanceManager() {
  const currentNarrative = useStoryStore((state) => state.currentNarrative);
  const advanceNarrative = useStoryStore((state) => state.advanceNarrative);
  const hasAutoAdvancedRef = useRef(false);

  // Reset the flag when narrative changes
  useEffect(() => {
    hasAutoAdvancedRef.current = false;
  }, [currentNarrative?.id]);

  const handleMediaEnded = () => {
    // Only auto-advance once per narrative
    if (hasAutoAdvancedRef.current) {
      console.log('[AutoAdvanceManager] Already auto-advanced for this narrative');
      return;
    }

    if (!currentNarrative?.autoAdvance) {
      console.log('[AutoAdvanceManager] AutoAdvance not enabled for narrative');
      return;
    }

    console.log('[AutoAdvanceManager] Media ended, auto-advancing narrative');
    hasAutoAdvancedRef.current = true;

    // Small delay to ensure smooth transition
    setTimeout(() => {
      advanceNarrative();
    }, 500);
  };

  // Export the handler for other components to use
  useEffect(() => {
    // Store the handler in window for global access
    (window as any).handleNarrativeMediaEnded = handleMediaEnded;

    return () => {
      delete (window as any).handleNarrativeMediaEnded;
    };
  }, [currentNarrative?.autoAdvance, currentNarrative?.id]);

  // This component renders nothing
  return null;
}
